import { LockOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const LOCK_FILE_MUTATION = graphql(`
  mutation LockFile($data: LockFileInput) {
    lockFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const LOCK_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment lockFileMenuItemFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof LOCK_FILE_MENU_ITEM_FILE_FRAGMENT>;
  canLock: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const LockFileMenuItem = ({
  file,
  canLock,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const { _id: fileId } = file;

  const [lockFile] = useMutation(LOCK_FILE_MUTATION, {
    completionMessage: `"${file?.filename}" was locked successfully`,
    optimisticResponse: {
      lockFile: {
        __typename: 'LockFileResult',
        file: {
          ...file,
          adminLock: true,
        },
      },
    },
  });

  return (
    <MaybeUsableMenuItem
      isUsable={canLock}
      isExpectedUsable={canLockRoot}
      unusableExplanation={unusableExplanation}
      onClick={() => {
        onClose();
        lockFile({
          variables: {
            data: { file: fileId },
          },
        });
      }}
    >
      <ListItemIcon>
        <LockOutlined />
      </ListItemIcon>
      <ListItemText primary="Lock" />
    </MaybeUsableMenuItem>
  );
};
